var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppBuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F0B429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8406 14.4336L27.7573 16.6169C29.174 17.2419 29.174 18.2753 27.7573 18.9003L22.8406 21.0836C22.2823 21.3336 21.3656 21.3336 20.8073 21.0836L15.8906 18.9003C14.474 18.2753 14.474 17.2419 15.8906 16.6169L20.8073 14.4336C21.3656 14.1836 22.2823 14.1836 22.8406 14.4336Z",
    stroke: "#010E20",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.167C14.5 21.867 15.025 22.6753 15.6667 22.9587L21.325 25.4753C21.7583 25.667 22.25 25.667 22.675 25.4753L28.3333 22.9587C28.975 22.6753 29.5 21.867 29.5 21.167",
    stroke: "#010E20",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25.333C14.5 26.108 14.9583 26.808 15.6667 27.1247L21.325 29.6413C21.7583 29.833 22.25 29.833 22.675 29.6413L28.3333 27.1247C29.0417 26.808 29.5 26.108 29.5 25.333",
    stroke: "#010E20",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBuilder);
export default __webpack_public_path__ + "static/media/app-builder.6e88271b707b5156afd5098bf14531dd.svg";
export { ForwardRef as ReactComponent };